import type { EndpointMap, ListResponse } from '../common';
import type { CreateFundRequest, ListFundsRequest, UpdateFundRequest } from './fund.request';
import type { CreateFundResponse, FundDetail, FundListItem } from './fund.response';

/**
 * 펀드 기본 CRUD. 목록은 페이지네이션 예외(DD-31). 조회 범위: D3 · 관리자 = 전체,
 * LP = 출자한 펀드, 포트폴리오 = 자기 회사에 투자한 펀드.
 */
export const fundEndpoints = {
  listFunds: {
    method: 'GET',
    path: '/funds',
    req: {} as ListFundsRequest,
    res: {} as ListResponse<FundListItem>,
    errors: ['BAD_REQUEST_INVALID_PARAMETERS'],
  },
  getFund: { method: 'GET', path: '/funds/:id', res: {} as FundDetail, errors: ['NOT_FOUND_FUND'] },
  createFund: {
    method: 'POST',
    path: '/funds',
    req: {} as CreateFundRequest,
    res: {} as CreateFundResponse,
    errors: ['BAD_REQUEST_INVALID_PARAMETERS'],
  },
  updateFund: {
    method: 'PATCH',
    path: '/funds/:id',
    req: {} as UpdateFundRequest,
    res: {} as FundDetail,
    errors: ['BAD_REQUEST_INVALID_PARAMETERS', 'NOT_FOUND_FUND', 'CONFLICT_FUND_CHANGED'],
  },
  deleteFund: {
    method: 'DELETE',
    path: '/funds/:id',
    res: undefined as void,
    errors: ['NOT_FOUND_FUND', 'CONFLICT_FUND_IN_USE'],
  },
} as const satisfies EndpointMap;
